import { readonly, toRefs, reactive } from 'vue'

import { type ErrorMessageModal } from '@/types/ErrorMessageModal'

export interface State {
  errorMessage: ErrorMessageModal | null
}

const state = reactive<State>({
  errorMessage: null
})

const clearErrorMessages = (): void => {
  state.errorMessage = null
}

export const addErrorMessages = (value: ErrorMessageModal): void => {
  state.errorMessage = value
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useErrorMessageModal () {
  return {
    ...toRefs(readonly(state)),
    clearErrorMessages
  }
}
